import { render, staticRenderFns } from "./KarmaCard.vue?vue&type=template&id=1980efa4&"
import script from "./KarmaCard.vue?vue&type=script&lang=ts&"
export * from "./KarmaCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VRating,VSubheader})
